import Vue from 'vue/dist/vue.esm.js';
import preventDefault from "@ckeditor/ckeditor5-ui/src/bindings/preventdefault";

export default {
    methods: {preventDefault}
}


Vue.component('online-consultation', {
    template: `#online-consultation`,
    delimiters: ['[[', ']]'],
    props: {
        categoriesJson: {},
    },
    data () {
        return {
            searchQuery: '',
            selectedCategories: [0],
            selectedCategory: 0,
            categories: JSON.parse(this.categoriesJson),
            questions: [],
            more: false,
            isLoading: false,
            loadingMore: false,
            nextPage: 1,
            expandedItems: []
        }
    },
    mounted() {
        this.fetchQuestions();
    },
    computed: {
        filteredQuestions() {
            return this.questions && this.questions.length > 0 && this.questions.filter(item => {
                const matchesSearch =
                    item['question'].toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    item.answer.toLowerCase().includes(this.searchQuery.toLowerCase())

                const matchesCategory =
                    this.selectedCategories.includes(0) ||
                    item.categories.some(category => this.selectedCategories.includes(category.id));

                return matchesSearch && matchesCategory
            })
        },
    },
    methods: {
        handleInput() {
            this.more = false;
            if(this.searchQuery.length > 3)
            {
                this.questions = [];
                this.nextPage = 1;
                this.fetchQuestions(1);
            }else if (this.searchQuery.length < 3){
                this.fetchQuestions(1);
            }
        },
        fetchQuestions(pageNumber = 1) {
            this.more = false;
            this.isLoading = true;

            let _self = this;
            const categories = this.selectedCategories.includes(0)
                ? [0]
                : this.selectedCategories;

            const url = "/ajax/online-consultation/questions?" + $.param({
                categoryIds: categories,
                page: pageNumber,
                searchQuery: this.searchQuery,
            });

            $.ajax({
                url: url,
                method: 'POST',
                processData: false,
                contentType: false,
                success: (response) => {
                    if (response.results) {

                        const newQuestions = response.results.map(q => ({
                            ...q,
                            showAnswer: false
                        }));

                        this.questions = pageNumber === 1
                            ? newQuestions
                            : [...this.questions, ...newQuestions];

                        _self.more = response.more;
                        _self.nextPage = response.nextPage;
                    }

                    setTimeout(() => {
                        _self.isLoading = false;
                        _self.loadingMore = false;
                        _self.selectedCategory = 0;
                    }, 350)
                },
                error: (error) => {
                    setTimeout(() => {
                        _self.isLoading = false;
                        _self.loadingMore = false;
                        _self.selectedCategory = 0;
                    }, 350)
                    console.error(error);
                }
            });
        },
        handleSelect(categoryId) {
            this.selectedCategory = categoryId;
            if (categoryId === 0) {
                this.selectedCategories = [0];
            } else {
                const index = this.selectedCategories.indexOf(categoryId);
                if (index === -1) {
                    this.selectedCategories = this.selectedCategories.filter(id => id !== 0);
                    this.selectedCategories.push(categoryId);
                } else {
                    this.selectedCategories.splice(index, 1);
                    if (this.selectedCategories.length === 0) {
                        this.selectedCategories = [0];
                    }
                }
            }
            this.fetchQuestions(1);
        },
        isSelected(categoryId) {
            return this.selectedCategories.includes(categoryId);
        },
        loadMore() {
            if (this.more) {
                this.loadingMore = true;
                this.fetchQuestions(this.nextPage);
            }
        },
        // filteredQuestions() {
        //     return this.questions && this.questions.length > 0 && this.questions.filter(item => {
        //         const matchesSearch =
        //             item.question.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        //             item.answer.toLowerCase().includes(this.searchQuery.toLowerCase())
        //         const matchesCategory =
        //             this.selectedCategory === 'all' ||
        //             item.category === this.selectedCategory
        //         return matchesSearch && matchesCategory
        //     })
        // },
        toggleItem(itemId) {
            const index = this.expandedItems.indexOf(itemId)
            if (index === -1) {
                this.expandedItems.push(itemId)
            } else {
                this.expandedItems.splice(index, 1)
            }
        },
        toggleAnswerVisibility(questionId) {
            const question = this.questions.find(q => q.id === questionId);
            if (question) {
                question.showAnswer = !question.showAnswer; // Toggle the visibility
            }
        },
    }
});
